module.exports = __webpack_public_path__ + "static/media/PM32.8071a062.png";